
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/succesverhaal/[slug]",
      function () {
        return require("private-next-pages/succesverhaal/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/succesverhaal/[slug]"])
      });
    }
  